/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { TurboHandler } from '@silarhi/turbo'
import initAlert from '@/js/actions/alert'
import initModalClose from '@/js/actions/modal-close'
import initNotification from '@/js/actions/notification'
import initShareSuccess from '@/js/actions/share-success'
import initToast from '@/js/actions/toast'

/**
 * Wire the Turbo custom actions, the form-confirm dialog, and the TurboHandler
 * that drives `App.mount` / `App.unmount` across Drive / Frame / Stream renders.
 *
 * The lifecycle orchestration now lives in `@silarhi/turbo` (TurboHandler); this
 * file only wires the app-specific bits — the custom StreamActions and the
 * `Turbo.config.forms.confirm` dialog. Runs once at boot.
 *
 * @type {Module}
 */
export default function init({ app }) {
    initAlert({ app })
    initShareSuccess({ app })
    initModalClose()
    initToast({ app })
    initNotification({ app })

    Turbo.config.forms.confirm = async (message) => {
        /** @type {ModalManager} */
        const modalManager = app.get('modalManager')
        return modalManager.createConfirm({ text: message })
    }

    // streamMutations defaults to true: diff the DOM around every Turbo Stream
    // (incl. Mercure) render and mirror it into mount/unmount, so per-mount
    // listeners init on stream-inserted content. mms relies on this.
    new TurboHandler({
        onMount: (container) => app.mount(container),
        onUnmount: (container) => app.unmount(container),
        onRedirect: (url) => app.loadUrl(url),
    }).start()
}
